export const ColorPalette = [
  "#D98880", // Muted Rose
  "#BB8FCE", // Soft Lavender
  "#82E0AA", // Gentle Mint
  "#7FB3D5", // Calm Sky Blue
  "#F7DC6F", // Warm Soft Yellow
  "#F5B041", // Muted Amber
  "#76D7C4", // Soft Teal
  "#AF7AC5", // Light Purple
  "#F0B27A", // Peachy Tone
  "#73C6B6", // Dusty Cyan
  "#85929E", // Soft Slate Gray
  "#D7BDE2", // Light Mauve
  "#AED6F1", // Pale Blue
  "#F9E79F", // Light Gold
  "#D5DBDB", // Gentle Gray
  "#A3E4D7", // Pale Aqua
  "#E59866", // Light Orange
  "#B2BABB", // Cool Gray
  "#BB8FCE", // Lavender Mist
  "#48C9B0", // Soft Aqua
  "#EC7063", // Soft Coral
  "#F4D03F", // Sunlit Yellow
  "#5DADE2", // Soft Blue
  "#FAD7A0", // Light Apricot
  "#D7BDE2", // Pale Violet
  "#73C6B6", // Muted Cyan
  "#EB984E", // Warm Pumpkin
  "#7FB3D5", // Calm Blue
  "#D98880", // Muted Coral
  "#A9CCE3", // Powder Blue
  "#58D68D", // Soft Green
  "#F0B27A", // Soft Orange
  "#85929E", // Slate Gray
  "#BB8FCE", // Light Purple
  "#F7DC6F", // Pale Yellow
  "#73C6B6", // Dusty Cyan
  "#E59866", // Warm Brownish Orange
  "#48C9B0", // Aqua Blue
  "#D5DBDB", // Light Gray
  "#AED6F1", // Light Sky Blue
  "#F9E79F", // Soft Gold
  "#A3E4D7", // Pale Aqua
  "#EC7063", // Soft Red
  "#5DADE2", // Soft Blue
  "#FAD7A0", // Light Apricot
  "#D7BDE2", // Lavender Mist
  "#58D68D", // Mint Green
  "#E59866", // Light Orange
];
export function getColor(index, name = "") {
  if (typeof index === "number" && index >= 0 && index < ColorPalette.length) {
    return ColorPalette[index];
  }
  // If index is out of range or not a number, use name to generate a color index
  if (typeof name === "string" && name.length > 0) {
    // Simple hash: sum char codes, mod palette length
    const hash = name
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return ColorPalette[hash % ColorPalette.length];
  }
  // Fallback color
  return "#888888";
}
